import React from "react";
import ReactQuill, { Quill } from "react-quill";
import { ImageDrop } from "quill-image-drop-module";
import { ImagePaste } from "./CustomImagePaste";
import "react-quill/dist/quill.snow.css";

Quill.register("modules/imagePaste", ImagePaste);
Quill.register("modules/imageDrop", ImageDrop);

export default function CustomQuill({ input, ...props }) {
  if (!input) {
    console.warn("You shold pass this component to a Fild");
    return null;
  }

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
    imageDrop: true,
    imagePaste: {},
  };

  return (
    <ReactQuill
      {...props}
      theme="snow"
      onChange={input.onChange}
      modules={modules}
      value={input.value}
    />
  );
}
